import React from "react";

export const SearchIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 17.5L13.9584 13.9521M15.9211 9.21053C15.9211 10.9903 15.2141 12.6971 13.9556 13.9556C12.6971 15.2141 10.9903 15.9211 9.21053 15.9211C7.43078 15.9211 5.72394 15.2141 4.46547 13.9556C3.207 12.6971 2.5 10.9903 2.5 9.21053C2.5 7.43078 3.207 5.72394 4.46547 4.46547C5.72394 3.207 7.43078 2.5 9.21053 2.5C10.9903 2.5 12.6971 3.207 13.9556 4.46547C15.2141 5.72394 15.9211 7.43078 15.9211 9.21053Z"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
